import { ButtonIcon, TrashIcon, Tooltip } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';
import { useEditor, useMutations, useSelection } from 'craft/hooks';

export const DeleteButton = () => {
  const { query } = useEditor();
  const { deleteNode } = useMutations();
  const { selection } = useSelection();

  if (selection.isEmpty || selection.hasRootNode) {
    return null;
  }

  const onDelete = () => deleteNode(selection.all);

  const isDisabled = selection.all.some((nodeId: string) => {
    const node = query.node(nodeId);
    if (!node) {
      return true;
    }
    return !node.isDeletable();
  });

  return (
    <Tooltip
      placement="top"
      offset="xxs"
      content={
        <TooltipBodyWithShortcuts
          content={isDisabled ? 'At least one selected content is not deletable' : 'Delete'}
          shortcuts={isDisabled ? [] : ['Delete']}
        />
      }
    >
      <ButtonIcon
        disabled={isDisabled}
        size="small"
        icon={TrashIcon}
        onClick={onDelete}
        radius="small"
        color="white"
      />
    </Tooltip>
  );
};
